import React from 'react';
import { pdf } from '@react-pdf/renderer';
import ThermalReceiptPdf from './ThermalReceiptPdf';
import ThermalReturnReceiptPdf from './ThermalReturnReceiptPdf';

export const buildReceiptPdfBlob = (receipt) =>
  pdf(<ThermalReceiptPdf receipt={receipt} />).toBlob();

// The credit note / return receipt, in the same style as the printed one.
export const buildReturnReceiptPdfBlob = (receipt) =>
  pdf(<ThermalReturnReceiptPdf receipt={receipt} />).toBlob();

export const downloadReceiptPdf = async ({ receipt, filename }) => {
  const blob = await buildReceiptPdfBlob(receipt);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
